function configureTime(opts) {
  void opts.replicantClientPromise.then(async (replicant) => {
    if (!opts.gcinstant.setTime) {
      return;
    }
    opts.gcinstant.setTime(replicant.now());
  });
}
export {
  configureTime
};
